import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

export const MainText = styled(Typography)({
    fontFamily: 'PlayfairDisplayVariable',
    fontVariationSettings: '"wght" 800',
    fontWeight: 800,
    fontSize: '16px',
  });
